import { Component } from '@angular/core';
import { ORCIDEmploymentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Employments') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidemployment-form',
    templateUrl: './orcidemployment.form.component.html'
})
export class ORCIDEmploymentFormComponent extends BaseFormComponent {
    public record!: ORCIDEmploymentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

